import { EnumBookerPaymentTimingConsolidation } from "gql/generated";
import { useBookerContext, useCartContext } from "widgets/booker/contexts";
import { isAfterServiceCheckout } from "widgets/booker/shared/utils";
import { useIsBookingRequest } from "./useIsBookingRequest";

export const useIsInvoicedAfterService = () => {
  const { booker, product, paymentRequestId, invoiceAdminMode } =
    useBookerContext();
  const { customerEligibility, grandTotal } = useCartContext();
  const isBookingRequest = useIsBookingRequest();
  const paymentTiming = booker?.paymentTiming;
  const isInvoicedAfterService =
    !invoiceAdminMode &&
    !isBookingRequest &&
    isAfterServiceCheckout({
      timing: paymentTiming?.timing,
      eligible:
        customerEligibility.eligible && !customerEligibility.loading,
      paymentRequestId,
      productType: product?.type,
      total: grandTotal,
    });
  return {
    isInvoicedAfterService,
    isMonthlyStatement:
      isInvoicedAfterService &&
      paymentTiming?.consolidation ===
        EnumBookerPaymentTimingConsolidation.MonthlyStatement,
  };
};
